import { logController } from "../../controllers/log.controller";
import { LogLevel } from "../../enums";
import { authenticationService } from "../../services/authentication.service";
import { history } from "./History";

/**
 * Provede kontrolu úspěšné autentizace a případně přesměruje na přihlašovací stránku.
 *
 * @export
 * @param {*} response
 * @returns
 */
export function handleResponse(response) {
    return response.text().then((text) => {
        var data = text;
        try {
            data = text && JSON.parse(text);
        } catch (e) {
            logController.logMessage("HandleResponse: JSON parse error: " + text, LogLevel.Error);
        }

        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                logController.logMessage(
                    `HandleResponse: Auto logout because ${response.status} ${response.statusText} response was returned from API (URL: ${response.url}).`,
                    LogLevel.Error
                );
                authenticationService.logout();
                this.props.history.push("/login");
            }

            var error = (data && data.errorMessage) || (data && data.detail) || (`${response.status} ${response.statusText}`);

            logController.logMessage(
                `HandleResponse: Error was returned from API (Status: ${response.status} ${response.statusText}, Error: ${error}, URL: ${response.url}).`,
                LogLevel.Error
            );
            
            return Promise.reject(error);
        }

        return data;
    });
}



// WEBPACK FOOTER //
// ./src/components/common/HandleResponse.js